import '../../utils/index.mjs';
import Affix from './src/affix2.mjs';
export { affixEmits, affixProps } from './src/affix.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElAffix = withInstall(Affix);

export { ElAffix, ElAffix as default };
//# sourceMappingURL=index.mjs.map
